import { combineEpics, ofType } from 'redux-observable';
import { pluck, switchMap } from 'rxjs/operators';

import { Epic } from 'src/config/rootEpic';

import { ProgramEnum } from '../../models/programs';
import {
    fetchProgramFeedbackFail,
    fetchProgramFeedbackSuccess,
    fetchWeekFeedbackFail,
    fetchWeekFeedbackSuccess,
    FETCH_PROGRAM_FEEDBACK_REQUESTED,
    FETCH_WEEK_FEEDBACK_REQUESTED,
    submitFeedbackFail,
    submitFeedbackSuccess,
    SUBMIT_FEEDBACK_REQUESTED,
} from '../actions/feedbackActions';
import { FetchWeekFeedbackData, SubmitFeedbackData } from '../models/feedback';
import { FeedbackService } from '../services/FeedbackService';

export function feedbackEpicFactory(feedbackService: FeedbackService): Epic {
    const fetchWeekFeedbackEpic: Epic = action$ =>
        action$.pipe(
            ofType(FETCH_WEEK_FEEDBACK_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: FetchWeekFeedbackData) =>
                    feedbackService
                        .fetchWeekFeedback(data)
                        .then(fetchWeekFeedbackSuccess)
                        .catch(fetchWeekFeedbackFail), // TODO: Inform user about error with toasts
            ),
        );

    const fetchProgramFeedbackEpic: Epic = action$ =>
        action$.pipe(
            ofType(FETCH_PROGRAM_FEEDBACK_REQUESTED),
            pluck('payload'),
            switchMap(
                (programId: ProgramEnum) =>
                    feedbackService
                        .fetchProgramFeedback(programId)
                        .then(fetchProgramFeedbackSuccess)
                        .catch(fetchProgramFeedbackFail), // TODO: Inform user about error with toasts
            ),
        );

    const submitFeedbackEpic: Epic = action$ =>
        action$.pipe(
            ofType(SUBMIT_FEEDBACK_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: SubmitFeedbackData) =>
                    feedbackService
                        .submitFeedback(data)
                        .then(submitFeedbackSuccess)
                        .catch(submitFeedbackFail), // TODO: Inform user about error with toasts
            ),
        );

    return combineEpics(fetchWeekFeedbackEpic, fetchProgramFeedbackEpic, submitFeedbackEpic);
}
